import { Api } from "queries/types";
import { useQuery } from "react-query";
import { get } from "./http";

const useShopFurnituresIndex = (brandId: number) =>
  useQuery<Api.ShopFurniture[]>(["shop_furnitures", brandId], () => get("/shop_furnitures", { params: { 'brands.erpName': brandId } }), { staleTime: Infinity });

export { useShopFurnituresIndex };
